export default __webpack_public_path__ + "static/media/compiegne2.7c0a0d44.jpg";